// extracted by mini-css-extract-plugin
module.exports = {"icon-success":"IconSuccess-IconSuccess-icon-success-2BhLBlXw","iconSuccess":"IconSuccess-IconSuccess-icon-success-2BhLBlXw"};